export type { GhostTextProps, GhostTextSlots, GhostTextState } from './components/GhostText/index';
export { GhostText, ghostTextClassNames, renderGhostText_unstable, useGhostTextStyles_unstable, useGhostText_unstable } from './components/GhostText/index';
export type { GhostTextPluginProps, SerializedGhostTextNode } from './plugins/GhostText/index';
export { $createGhostTextNode, $isGhostTextNode, GhostTextNode, GhostTextPlugin } from './plugins/GhostText/index';
export type { ManualGhostTextProps, ManualGhostTextRef } from './plugins/ManualGhostText/index';
export { ManualGhostTextPlugin } from './plugins/ManualGhostText/index';
